import { z } from 'zod';
import { timestampSchema } from './common';

export const questionHintSchema = z.object({
  id: z.uuid(),
  step: z.int().min(1),
  situation: z.string(),
  text: z.string(),
  model: z.string(),
  createdAt: timestampSchema,
  timesShown: z.int().min(0),
});

export const questionHintsSchema = z.object({ hints: z.array(questionHintSchema) });

export const hintParamsSchema = z.object({ hintId: z.uuid() });

export type QuestionHint = z.infer<typeof questionHintSchema>;
export type QuestionHints = z.infer<typeof questionHintsSchema>;
